import React from 'react';
import "./Brands.css";

const Brands = ({imageUrl, websiteLink}) => {
    return(
        <a href={websiteLink} className='brand-link' target="_blank" rel="noopener noreferrer">
            <img src={imageUrl} className='brand-container' alt="Brand Logo" />
        </a>
    );
};

export default Brands;
